import React from "react";
import { Link } from "react-router-dom";
import "../styles/HeroSection.css";
import downArrow from "../images/down.jpg";
import ragtowa from "../images/rag-towa.jpg";
import ragstyle from "../images/rag-style.jpg";
import ragsuccess from "../images/rag-success.jpg";
import ragin from "../images/rag-in.jpg";
import ragapproach from "../images/rag-approach.jpg";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";

function HeroSection() {
  return (
    <>
      <section className="hero">
        <h1 className="hero-title">生成AI導入・RAG開発サービス</h1>
      </section>

      <div className="hero-description">
        <p className="highlighted-paragraph">
          企業がAIを通じて新しい価値を創出し、業務効率を最大限に高めるための総合的なソリューションを提供します
        </p>
        <p>
          生成AIの導入からカスタマイズ開発、インフラ構築、データセキュリティ、運用・教育支援まで、企業のニーズに応じた支援を一貫して行います。生成AIの実装を通じて、持続可能なビジネス成長と業務革新を支援します。
        </p>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title">こんな課題にお悩みの方</h2>
        <ul className="problems-list">
          <li>
            業務が属人化しており、特定の担当者がいないと回らない状態になっている
          </li>
          <li>AI導入に興味はあるが、何から手を付ければよいか分からない</li>
          <li>
            社内のマニュアルやノウハウが散在しており、情報共有や引き継ぎが非効率
          </li>
          <li>顧客からの問い合わせ対応に時間がかかり、担当者の負担が大きい</li>
        </ul>
      </div>
      <div className="down-arrow-image">
        <img src={downArrow} alt="下向き矢印" />
      </div>
      <p className="cta-message">
        生成AI導入・RAG開発サービスを通じて、御社のAI活用と業務改善を一貫してサポートいたします。
      </p>

      <div className="hero-problems">
        <h2 className="problems-title">RAGとは</h2>
        <p className="rag-benefit">
          大規模言語モデル（LLM）が、独自および外部の知識（データベース、文書、ウェブサイトなど）から関連情報を取得し、その情報を基に回答を生成する技術です。
          RAGシステムでは、ユーザーからの質問に対して、関連する情報を探し出し、その検索結果と質問内容を組み合わせてLLMに入力し、回答を生成します。
        </p>
        <div className="rag-image1">
          <img src={ragtowa} alt="RAGとは" />
        </div>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title2">
          カスタマイズ生成AI・RAGの導入によるメリット
        </h2>
        <p className="rag-benefit">
          RAGの活用により、社内データをもとに自社特有の回答を生成できます。
        </p>
        <p className="rag-merit">【RAGを導入することで得られる効果】</p>
      </div>

      <div className="merit-section">
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="1"></div>
            <p className="merit-point-title">事実性（ファクト）の向上</p>
          </div>
          <span className="merit-point-sab">
            LLMはハルシネーション（もっともらしいけど事実ではない回答）をすることがありますが、RAGは信頼できるソースから情報を検索して引用することで、事実に基づいた応答が可能になります。
          </span>
        </div>
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="2"></div>
            <p className="merit-point-title">社内データや専門情報の活用</p>
          </div>
          <span className="merit-point-sab">
            RAGでは自社のナレッジベース（例：マニュアル、FAQ、議事録、報告書など）を情報源として組み込めるため、専門性の高い回答が可能になります。これにより社内向けチャットボットなどにも応用できます。
          </span>
        </div>
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="3"></div>
            <p className="merit-point-title">業務負担の軽減と生産性の向上</p>
          </div>
          <span className="merit-point-sab">
            RAGの導入により、情報検索や問い合わせ対応などの繰り返し業務をAIが担うことで、従業員の負担を軽減できます。より価値の高い業務に集中できる環境を実現し、チーム全体の生産性も向上します。
          </span>
        </div>
      </div>

      <div className="hero-problems">
        <p className="rag-merit">【RAGの活用で実現できること】</p>
      </div>

      <div className="merit-section">
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="1"></div>
            <p className="merit-point-title">カスタマーサポートの即時対応</p>
          </div>
          <span className="merit-point-sab">
            過去の問い合わせデータや製品マニュアルを読み込ませておけば、顧客からの質問に対し、迅速かつ的確に回答できるチャットボットを構築可能です。
          </span>
        </div>
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="2"></div>
            <p className="merit-point-title">新人研修の自動化サポート</p>
          </div>
          <span className="merit-point-sab">
            研修資料や業務マニュアルを元に、RAGが新入社員の疑問に答えるサポート役に。教育コストを抑えつつ、即戦力化を促進します。
          </span>
        </div>
        <div className="merit-point">
          <div className="merit-header">
            <div className="merit-point-number" data-number="3"></div>
            <p className="merit-point-title">営業資料や提案書の自動生成支援</p>
          </div>
          <span className="merit-point-sab">
            過去の提案書や社内資料をもとに、提案のたたき台となる文章を自動生成。資料作成にかかる時間を大幅に削減できます。
          </span>
        </div>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title2">RAGの基本的な仕組み</h2>
        <p className="rag-benefit">
          RAGでは資料をベクトル化したデータベースとLLMを連携させます。
        </p>
      </div>
      <div className="rag-image1">
        <img src={ragstyle} alt="RAGの仕組み" />
      </div>

      <div className="process-grid">
        <div className="process-box">
          <div className="process-title">ドキュメント</div>
          <div className="process-body">
            LLMに回答させたい内容を含むドキュメントを準備します。無益なデータが混在していると性能の低下を招くため、取捨選択します。
          </div>
        </div>
        <div className="process-box">
          <div className="process-title">抽出</div>
          <div className="process-body">
            データクレンジングを行い、PDFやHTML、Markdownなど形式の異なるファイルをプレーンテキストに変換します。
          </div>
        </div>
        <div className="process-box">
          <div className="process-title">チャンキング</div>
          <div className="process-body">
            情報を小さな単位 (チャンク)
            に分割します。チャンクは検索に利用されますが、適切なサイズの設定で回答精度が大きく向上します。
          </div>
        </div>
        <div className="process-box">
          <div className="process-title">インデックス化</div>
          <div className="process-body">
            チャンクと埋め込むデータ (ベクトル)
            をキーと値のペアの形で保存できるようにし、将来的に素早く頻繁に検索できるようにします。
          </div>
        </div>
      </div>
      <div className="process-grid">
        <div className="process-box">
          <div className="process-title">（単語）埋め込み</div>
          <div className="process-body">
            単語を多次元ベクトル化して割り当てます。これによって、文脈上意味が類似する単語がベクトル空間内で近いと判断できます。
          </div>
        </div>
        <div className="process-box">
          <div className="process-title">ベクトルDB</div>
          <div className="process-body">
            埋め込みしたベクトルを、DBに格納します。ここの出力は、ユーザの質問に含まれる状況や文脈であり、これがLLMの入力になります。
          </div>
        </div>
        <div className="process-box">
          <div className="process-title">LLM（大規模言語モデル）</div>
          <div className="process-body">
            情報を小さな単位 (チャンク)
            ここまでで作成した外部のベクトルDBと連携することで、RAGを実装したLLMとなります。実装後、性能をテスト/調整を行います。
          </div>
        </div>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title2">生成AI導入における成功の要諦</h2>
        <p className="rag-benefit">
          生成AI導入における懸念事項に対し、技術に関する深い知見と必要な業務への理解を基に、一気通貫して、“独自の生成AI（RAGシステム）”が定着化するまでの伴走、ご支援します。
        </p>
        <div className="rag-image2">
          <img src={ragsuccess} alt="成功の要諦" />
        </div>
      </div>
      <div className="rag-success-container">
        <p className="rag-success-message">
          生成AIを”導入して終わり”でなく、期待する効果に向けての最適な、成果を生み出すRAGシステムを創ります。
        </p>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title2">RAGシステムの導入方法</h2>
        <p className="rag-benefit">
          ｢言語モデル｣｢ベクトルDB｣｢サーバ｣の３つを用意する必要があります
        </p>
        <p className="rag-benefit">
          RAGの導入には様々なパターンがあり、実現内容や工数によって変わります。ここでは３つの導入例を紹介します。
        </p>
        <div className="rag-image2">
          <img src={ragin} alt="導入方法" />
        </div>
      </div>

      <div className="hero-problems">
        <h2 className="problems-title2">
          （依頼後）実際の本番運用までのアプローチ
        </h2>
        <p className="rag-benefit">
          RAGの本番導入において生成AIの精度がサービスの品質を左右する重要な要素であるため、単なる一括開発ではなく、PoC（概念検証）→
          MVPトライアル（試験運用）→
          本格開発のプロセスを段階的に進め、改善を繰り返しながら品質を高めていきます。
        </p>
        <div className="rag-image2">
          <img src={ragapproach} alt="アプローチ" />
        </div>
      </div>

      <div className="contact-container">
        <h3 className="contact-title">お問い合わせ</h3>
        <p className="contact-sab">
          まずはお気軽にご相談・お問い合わせください。
        </p>

        <div className="contact-button-container">
          <Link to="/download" className="download-button">
            <DownloadIcon
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            />
            資料をダウンロードする
          </Link>
          <Link to="/Inquiry" className="inquiry-button">
            <EmailIcon
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            />
            お問い合わせをする
          </Link>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
